export const INVALID_SEARCH = 'INVALID_SEARCH'

export type ActionType = {
  type: typeof INVALID_SEARCH
}

export const invalidSearch = (): ActionType => ({
  type: INVALID_SEARCH
})
